import {LngLat, LngLatBounds} from "maplibre-gl";
import DataChoice, {IDataChoices} from "../../model-factory/basic/data/DataChoice";
import {PostType} from "../../manager/post/PostManager";
import {IAnyObject, INumberObject} from "../../common/SimpleInterface";
import {getManager} from "../../manager/Manager";
import DataModel from "../../model-factory/basic/data/DataModel";
import DataFactory from "../../model-factory/basic/data/DataFactory";
import {CountryCode} from "../../../module/osm/location/LocationType";

export class LocatableDataChoice extends DataChoice
{
    lngLat:LngLat|null = null;
    lngLatBounds:LngLatBounds|null = null;
    countryCode:CountryCode|"" = "";
    postType:PostType|null = null;

    constructor(object:IAnyObject)
    {
        super(object);

    }

    getDistanceInMetres(fromLngLat:LngLat):number|null
    {
        if(!this.lngLat){
            return null;
        }
        return getManager().location.getDistanceInMetresBetween(fromLngLat, this.lngLat);
    }

    getReadableDistance(fromLngLat:LngLat):string|null
    {
        const distanceInMetres = this.getDistanceInMetres(fromLngLat);
        if(distanceInMetres === null){
            return null;
        }
        return getManager().location.getReadableDistance(distanceInMetres);
    }
}

export interface ILocatableDataChoices extends IDataChoices
{
    [key: string]: LocatableDataChoice;
}

export class LocatableDataModel extends DataModel
{
    choices: ILocatableDataChoices = {};


    createChoice(object: IAnyObject): LocatableDataChoice | null
    {
        return super.createChoice(object) as LocatableDataChoice;
    }

    factory(): LocatableDataFactory
    {
        return super.factory() as LocatableDataFactory;
    }
}


export default class LocatableDataFactory extends DataFactory
{

    birthDataChoice(object:IAnyObject): LocatableDataChoice
    {
        return new LocatableDataChoice(object);
    }
}

export const sortLocatableByNorthWest = (choiceList:LocatableDataChoice[]) => {
    let bounds:LngLatBounds|null = null;

    const distances:INumberObject = {};
    const choiceOrder:string[] = [];
    for(let choice of choiceList){
        choiceOrder.push(choice.id)
        if(choice.lngLat){
            if(choice.lngLat){
                if(!bounds){
                    bounds = new LngLatBounds(choice.lngLat, choice.lngLat);
                } else{
                    bounds.extend(choice.lngLat);
                }
            }
        }
    }
    if(!bounds)
    {
        return
    }

    for(let choice of choiceList){
        if(choice.lngLat){
            distances[choice.id] = choice.getDistanceInMetres(bounds.getNorthWest())!;
        }
    }

    choiceList.sort((a, b) => {
        const aDistance = distances[a.id] ?? null;
        const bDistance = distances[b.id] ?? null;
        if(aDistance !== null && bDistance !== null){
            if(aDistance < bDistance){
                return  -1;
            }
            if(aDistance > bDistance){
                return  1;
            }
        }
        if(bDistance === null){
            return  -1;
        }
        if(aDistance === null){
            return  1;
        }
        let aIndex = choiceOrder.indexOf(a.id);
        let bIndex = choiceOrder.indexOf(b.id);

        return aIndex <= bIndex ? -1 : 1;
    });
}